import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemApplicationEditRoute: InvariantJiraRoute = {
	name: 'global-settings-system-application-edit',
	path: '/secure/admin/EditApplicationProperties([!%]?[\\w]*).jspa',
};
